'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_io$002eintela$002esites$002edigitalinternship$002e$002dPage$0024$002dSegment$002dKey from "./io.intela.sites.digitalinternship.-Page$-Segment-Key.js";
var $p;
/** @constructor */
function $c_Lio_intela_sites_digitalinternship_Page$SegmentKey$$anon$8() {
  this.d2 = null;
  this.dJ = null;
  $j_io$002eintela$002esites$002edigitalinternship$002e$002dPage$0024$002dSegment$002dKey.$ct_Lio_intela_sites_digitalinternship_Page$SegmentKey__T__T__(this, "teachers", "/teachers");
}
export { $c_Lio_intela_sites_digitalinternship_Page$SegmentKey$$anon$8 as $c_Lio_intela_sites_digitalinternship_Page$SegmentKey$$anon$8 };
$p = $c_Lio_intela_sites_digitalinternship_Page$SegmentKey$$anon$8.prototype = new $j_io$002eintela$002esites$002edigitalinternship$002e$002dPage$0024$002dSegment$002dKey.$h_Lio_intela_sites_digitalinternship_Page$SegmentKey();
$p.constructor = $c_Lio_intela_sites_digitalinternship_Page$SegmentKey$$anon$8;
/** @constructor */
function $h_Lio_intela_sites_digitalinternship_Page$SegmentKey$$anon$8() {
}
export { $h_Lio_intela_sites_digitalinternship_Page$SegmentKey$$anon$8 as $h_Lio_intela_sites_digitalinternship_Page$SegmentKey$$anon$8 };
$h_Lio_intela_sites_digitalinternship_Page$SegmentKey$$anon$8.prototype = $p;
$p.G = (function() {
  return 0;
});
$p.H = (function(n) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_sr_EnumValue__productElement__I__O(this, n);
});
$p.I = (function() {
  return "Teachers";
});
$p.t = (function() {
  return "Teachers";
});
$p.s = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_T__hashCode__I("Teachers");
});
var $d_Lio_intela_sites_digitalinternship_Page$SegmentKey$$anon$8 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lio_intela_sites_digitalinternship_Page$SegmentKey$$anon$8, "io.intela.sites.digitalinternship.Page$SegmentKey$$anon$8", ({
  f3: 1,
  a9: 1,
  b: 1,
  e: 1,
  a: 1,
  C: 1,
  V: 1,
  y: 1,
  N: 1,
  S: 1
}));
export { $d_Lio_intela_sites_digitalinternship_Page$SegmentKey$$anon$8 as $d_Lio_intela_sites_digitalinternship_Page$SegmentKey$$anon$8 };
//# sourceMappingURL=io.intela.sites.digitalinternship.-Page$-Segment-Key$$anon$8.js.map
